import { render, staticRenderFns } from "./NoteField.vue?vue&type=template&id=3be0a3b5&scoped=true"
import script from "./NoteField.vue?vue&type=script&lang=js"
export * from "./NoteField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0a3b5",
  null
  
)

export default component.exports